"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var material_1 = require("@mui/material");

var style_1 = require("./style");

var Dialog = function (props) {
  var header = props.header,
      body = props.body,
      size = props.size,
      actions = props.actions,
      open = props.open;
  var dialogWidth;

  switch (size) {
    case 'xs':
      dialogWidth = style_1.styles.xs;
      break;

    case 'small':
      dialogWidth = style_1.styles.small;
      break;

    case 'medium':
      dialogWidth = style_1.styles.medium;
      break;

    case 'large':
      dialogWidth = style_1.styles.large;
      break;

    default:
      dialogWidth = style_1.styles.xs;
  }

  ;
  return react_1["default"].createElement(material_1.Dialog, {
    open: open,
    css: dialogWidth
  }, react_1["default"].createElement(material_1.DialogTitle, {
    id: "alert-dialog-title"
  }, header), react_1["default"].createElement(material_1.DialogContent, null, react_1["default"].createElement(material_1.DialogContentText, {
    id: "alert-dialog-description"
  }, body)), react_1["default"].createElement(material_1.DialogActions, null, actions.map(function (action, index) {
    return react_1["default"].createElement("div", {
      key: index
    }, action);
  })));
};

exports["default"] = Dialog;